import { Close, Handyman } from "@mui/icons-material"
import { Box, Dialog, DialogContent, DialogTitle, FormGroup, FormLabel, IconButton, TextField, Tooltip } from "@mui/material"
import { useMemo, useState } from "react"
import { isUserAdministrator } from "src/utils/auth"
import { Id } from "src/utils/types"
import Form, { HandleSubmitHandler as SubmitFunction } from "../Form"
import { adjustWalletBalance } from "src/apis/eezycoin"
import FormSaveAndResetButtons from "../FormSaveAndResetButtons"

type EezycoinWalletAdjustmentDialogProps = {
  walletId: Id,
  walletOriginalBalance: number,
  setError: (err: any) => void,
}

export default function EezycoinWalletAdjustmentDialog({
  walletId,
  walletOriginalBalance,
  setError,
}: EezycoinWalletAdjustmentDialogProps) {
  const [open, setOpen] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const [success, setSuccess] = useState<boolean>(false)
  const [balance, setBalance] = useState<number>(walletOriginalBalance)

  const isAdmin = useMemo(isUserAdministrator, [])

  const onClose = (): void => setOpen(false)

  const onOpen = (): void => setOpen(true)

  const handleSubmit: SubmitFunction = async (e) => {
    e.preventDefault()

    setLoading(true)

    try {
      await adjustWalletBalance(walletId, balance, walletOriginalBalance)

      setError(null)
      setSuccess(true)
    } catch (err: any) {
      setError(err)
      setSuccess(false)
    } finally {
      setLoading(false)
    }
  }

  if (!isAdmin) {
    return <></>
  }

  return <>
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
      >
        <Box display="flex" alignItems="center" gap={1}>
          Eezycoin - Ajustar saldo
        </Box>
        <IconButton size="small" onClick={onClose}>
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Form handleSubmit={handleSubmit}>
          <FormGroup>
            <FormLabel>
              Saldo original da conta
            </FormLabel>
            <TextField
              disabled
              type="number"
              value={walletOriginalBalance}
              onChange={(e) => {}}
            />
          </FormGroup>
          <FormGroup>
            <FormLabel>
              Saldo correto da conta
            </FormLabel>
            <TextField
              type="number"
              value={balance}
              onChange={(e) => {
                setBalance(parseInt(e.target.value))
              }}
            />
          </FormGroup>

          <FormSaveAndResetButtons
            isResetFormStateDisabled
            loading={loading}
            isSubmitDisabled={loading}
            success={success}
          />
        </Form>
      </DialogContent>
    </Dialog>

    <Tooltip title="Ajustar saldo">
      <IconButton
        size="small"
        onClick={onOpen}
      >
        <Handyman fontSize="small" />
      </IconButton>
    </Tooltip>
  </>
}
